<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="main-card" flat>
      <v-tabs v-model="tabs" background-color="transparent" centered grow show-arrows slider-color="transparent"
        class="custom-tabs">
        <v-tab v-if="profile_relative_tab.indexOf('Under_skillsandinterests_tab_skills') !== -1"
          :class="['custom-tab', 'first-tab', { 'active-tab': tabs === 0 }]">
          <v-icon class="mr-2">mdi-lightbulb-on-outline</v-icon>Skills
        </v-tab>
        <v-tab :class="['custom-tab', { 'active-tab': tabs === 1 }]"
          v-if="profile_relative_tab.indexOf('Under_skillsandinterests_tab_interests') !== -1">
          <v-icon class="mr-2">mdi-heart-box-outline</v-icon>Interests
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <!-- Skills Tab -->
        <v-tab-item v-if="profile_relative_tab.indexOf('Under_skillsandinterests_tab_skills') !== -1">
          <v-card flat>
            <v-data-table :headers="headers" :items="skills_list" :sort-by="['srno']" class="elevation-1"
              style="padding: 10px" :search="search" hide-default-header>
              <template v-slot:header="{ props }">
                <thead>
                  <tr>
                    <th v-for="header in props.headers" :key="header.value" class="custom-header">
                      {{ header.text }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:top>
                <v-toolbar dense flat class="custom-toolbar ma-2">
                  <v-toolbar-title>Skill Details</v-toolbar-title>
                </v-toolbar>
                <v-row justify="left" dense>
                  <v-col sm="3" md="3" cols="12"></v-col>
                  <v-col sm="6" md="4" cols="12" class="pt-0 pb-5">
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                      hide-details></v-text-field>
                  </v-col>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mb-2 button" v-on="on" small>Add Skill</v-btn>
                    </template>
                    <v-card>
                      <v-form ref="skillForm" v-model="validSkills">
                        <v-card-title class="custom-toolbar">
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col v-for="field in skillFields" :key="field.field_name" cols="12" sm="12" md="12"
                                v-if="field.isactive">
                                <div class="pl-1 pb-2" style="font-size: 14px;">
                                  <b>{{ field.label }}</b>
                                  <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>
                                </div>
                                <v-select v-model="editedItem[field.field_name]"
                                  :items="field.options && Array.isArray(field.options) ? field.options : skill_master_list"
                                  item-text="name" item-value="id" dense outlined rounded
                                  :placeholder="field.placeholder || `Select ${field.label.toLowerCase()}`"
                                  :rules="field.required ? [(v) => !!v || `${field.label} is required`] : []"
                                  :readonly="editedIndex !== -1 && !field.iseditable"
                                  :filled="editedIndex !== -1 && !field.iseditable" />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="mb-2 button" small @click="close">Cancel</v-btn>
                          <v-btn class="button-77" :loading="save_loader" :disabled="!validSkills" text
                            @click="saveSkillsDetails()">Save</v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
              <template v-slot:item.action="{ item }">
                <v-avatar size="25" class="edit-avatar mr-2">
                  <v-icon class="edit-v-icon mr-2" @click="editItem(item)" color="success">edit</v-icon>
                </v-avatar>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-avatar size="35">
                  <v-icon class="mr-4 v-icon-size" color="red" @click="deleteItem(item)">mdi-trash-can</v-icon>
                </v-avatar>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <!-- Interests Tab -->
        <v-tab-item v-if="profile_relative_tab.indexOf('Under_skillsandinterests_tab_interests') !== -1">
          <v-card flat>
            <v-data-table :headers="headers1" :items="interest_list" :sort-by="['srno']" class="elevation-1"
              style="padding: 10px" :search="search1" hide-default-header>
              <template v-slot:header="{ props }">
                <thead>
                  <tr>
                    <th v-for="header1 in props.headers" :key="header1.value" class="custom-header">
                      {{ header1.text }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:top>
                <v-toolbar dense flat class="custom-toolbar ma-2">
                  <v-toolbar-title>Interest Details</v-toolbar-title>
                </v-toolbar>
                <v-row justify="left" dense>
                  <v-col sm="3" md="3" cols="12"></v-col>
                  <v-col sm="6" md="4" cols="12" class="pt-0 pb-5">
                    <v-text-field v-model="search1" append-icon="search" label="Search" single-line
                      hide-details></v-text-field>
                  </v-col>
                  <v-dialog v-model="dialog1" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mb-2 button" v-on="on" small>Add Interest</v-btn>
                    </template>
                    <v-card>
                      <v-form ref="interestForm" v-model="validInterests">
                        <v-card-title class="custom-toolbar">
                          <span class="headline">{{ formTitle1 }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col v-for="field in interestFields" :key="field.field_name" cols="12" sm="12" md="12"
                                v-if="field.isactive">
                                <div class="pl-1 pb-2" style="font-size: 14px;">
                                  <b>{{ field.label }}</b>
                                  <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>
                                </div>
                                <v-select v-model="editedItem_interest[field.field_name]"
                                  :items="field.options && Array.isArray(field.options) ? field.options : interest_master_list"
                                  item-text="name" item-value="id" dense outlined rounded
                                  :placeholder="field.placeholder || `Select ${field.label.toLowerCase()}`"
                                  :rules="field.required ? [(v) => !!v || `${field.label} is required`] : []"
                                  :readonly="editedIndex_interest !== -1 && !field.iseditable"
                                  :filled="editedIndex_interest !== -1 && !field.iseditable" />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="mb-2 button" small @click="close1">Cancel</v-btn>
                          <v-btn class="button-77" :loading="save_loader1" :disabled="!validInterests" text
                            @click="saveLearnerInterest()">Save</v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
              <template v-slot:item.action="{ item }">
                <v-avatar size="25" class="edit-avatar mr-2">
                  <v-icon class="edit-v-icon mr-2" @click="editItemInterest(item)" color="success">edit</v-icon>
                </v-avatar>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-avatar size="35">
                  <v-icon class="mr-4 v-icon-size" color="red" @click="deleteItemInterest(item)">mdi-trash-can</v-icon>
                </v-avatar>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    props: {
      learner: {
        type: [String, Number],
        required: true,
      },
      profile_relative_tab: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        save_loader: false,
        save_loader1: false,
        dialog: false,
        dialog1: false,
        editedIndex: -1,
        editedIndex_interest: -1,
        editedItem: {},
        defaultItem: {},
        editedItem_interest: {},
        defaultItem_interest: {},
        validSkills: true,
        validInterests: true,
        tabs: 0,
        skills_list: [],
        skillFields: [],
        skill_master_list: [],
        interest_list: [],
        interestFields: [],
        interest_master_list: [],
        color: "",
        snackbar: false,
        snackbar_msg: "",
        search: "",
        search1: "",
        headers: [
          { text: "Sr.No", align: "left", sortable: false, value: "srno" },
          { text: "Skill", align: "left", sortable: false, value: "name" },
          { text: "Edit", value: "action", sortable: false },
          { text: "Delete", value: "delete", sortable: false },
        ],
        headers1: [
          { text: "Sr.No", align: "left", sortable: false, value: "srno" },
          { text: "Interest", align: "left", sortable: false, value: "name" },
          { text: "Edit", value: "action", sortable: false },
          { text: "Delete", value: "delete", sortable: false },
        ],
      };
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Add Skill" : "Edit Skill";
      },
      formTitle1() {
        return this.editedIndex_interest === -1 ? "Add Interest" : "Edit Interest";
      },
    },
    watch: {
      learner(newVal) {
        if (newVal) {
          this.getSkillDetails();
          this.getLearnerInterest();
        }
      },
    },
    methods: {
      saveSkillsDetails() {
        if (!this.$refs.skillForm.validate()) {
          this.showSnackbar("#b71c1c", "Please fill all required fields");
          return;
        }

        const isEdit = this.editedIndex > -1;
        this.save_loader = true;
        const formData = new FormData();
        formData.append("learner", this.learner);
        if (this.editedItem.skill_name) {
          formData.append("skill", this.editedItem.skill_name);
        }
        if (isEdit && this.editedItem.id) {
          formData.append("id", this.editedItem.id);
        }

        axios
          .post("/parent/saveSkillDetails", formData)
          .then((res) => {
            if (res.data.status.code === "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                isEdit ? "Student Skill updated successfully" : "Student Skill added successfully"
              );
              this.getSkillDetails();
            } else if (res.data.status.code === "NA") {
              this.showSnackbar("#b71c1c", res.data.status.message || "Skill already exists");
            } else if (res.data.status.code === "NOT_FOUND") {
              this.showSnackbar("#b71c1c", res.data.status.message || "Skill not found");
            } else {
              this.showSnackbar("#b71c1c", "Unexpected server response");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong");
            console.error(error);
          })
          .finally(() => {
            this.save_loader = false;
            this.close();
          });
      },
      saveLearnerInterest() {
        if (!this.$refs.interestForm.validate()) {
          this.showSnackbar("#b71c1c", "Please fill all required fields");
          return;
        }

        const isEdit = this.editedIndex_interest > -1;
        this.save_loader1 = true;
        const formData = new FormData();
        formData.append("learner", this.learner);
        if (this.editedItem_interest.interest_name) {
          formData.append("interest", this.editedItem_interest.interest_name);
        }
        if (isEdit && this.editedItem_interest.id) {
          formData.append("id", this.editedItem_interest.id);
        }

        axios
          .post("/parent/saveLearnerInterest", formData)
          .then((res) => {
            if (res.data.status.code === "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                isEdit ? "Student Interest updated successfully" : "Student Interest added successfully"
              );
              this.getLearnerInterest();
            } else if (res.data.status.code === "NA") {
              this.showSnackbar("#b71c1c", res.data.status.message || "Interest already exists");
            } else if (res.data.status.code === "NOT_FOUND") {
              this.showSnackbar("#b71c1c", res.data.status.message || "Interest not found");
            } else {
              this.showSnackbar("#b71c1c", "Unexpected server response");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong");
            console.error(error);
          })
          .finally(() => {
            this.save_loader1 = false;
            this.close1();
          });
      },
      deleteItem(item) {
        const formData = new FormData();
        formData.append("id", item.id);

        axios
          .post("/parent/deleteSkillDetails", formData)
          .then((res) => {
            if (res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Student Skill deleted successfully");
              this.getSkillDetails();
            } else if (res.data.status.code === "NOT_FOUND") {
              this.showSnackbar("#b71c1c", "Skill not found");
            } else {
              this.showSnackbar("#b71c1c", "Failed to delete skill");
            }
          })
          .catch((error) => {
            console.error(error);
            this.showSnackbar("#b71c1c", "Something went wrong");
          });
      },
      deleteItemInterest(item) {
        const formData = new FormData();
        formData.append("id", item.id);

        axios
          .post("/parent/deleteLearnerInterest", formData)
          .then((res) => {
            if (res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Student Interest deleted successfully");
              this.getLearnerInterest();
            } else if (res.data.status.code === "NOT_FOUND") {
              this.showSnackbar("#b71c1c", "Interest not found");
            } else {
              this.showSnackbar("#b71c1c", "Failed to delete interest");
            }
          })
          .catch((error) => {
            console.error(error);
            this.showSnackbar("#b71c1c", "Something went wrong");
          });
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
      getSkillDetails() {
        const data = { learner: this.learner };
        axios.post("/parent/getSkillDetails", data).then((res) => {
          if (res.data.flag === "YES") {
            this.skills_list = res.data.skills_list || [];
            this.skillFields = res.data.skillFields || [];
            this.skill_master_list = res.data.skill_master_list || [];
            // Initialize defaultItem dynamically
            this.defaultItem = {};
            this.skillFields.forEach(field => {
              this.defaultItem[field.field_name] = null;
            });
            this.editedItem = Object.assign({}, this.defaultItem);
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar || "Error loading skills");
          }
        }).catch((error) => {
          console.error("Error fetching skills:", error);
          this.showSnackbar("#b71c1c", "Failed to load skills");
        });
      },
      getLearnerInterest() {
        const data = { learner: this.learner };
        axios.post("/parent/getLearnerInterest", data).then((res) => {
          if (res.data.flag === "YES") {
            this.interest_list = res.data.interest_list || [];
            this.interestFields = res.data.interestFields || [];
            this.interest_master_list = res.data.interest_master_list || [];
            // Initialize defaultItem_interest dynamically
            this.defaultItem_interest = {};
            this.interestFields.forEach(field => {
              this.defaultItem_interest[field.field_name] = null;
            });
            this.editedItem_interest = Object.assign({}, this.defaultItem_interest);
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar || "Error loading interests");
          }
        }).catch((error) => {
          console.error("Error fetching interests:", error);
          this.showSnackbar("#b71c1c", "Failed to load interests");
        });
      },
      editItem(item) {
        this.editedIndex = this.skills_list.indexOf(item);
        this.editedItem = { id: item.id };
        this.skillFields.forEach(field => {
          if (field.field_name === 'skill_name') {
            this.editedItem[field.field_name] = item.skill; // Set to skill ID
          } else {
            this.editedItem[field.field_name] = null;
          }
        });
        this.dialog = true;
      },
      editItemInterest(item) {
        this.editedIndex_interest = this.interest_list.indexOf(item);
        this.editedItem_interest = { id: item.id };
        this.interestFields.forEach(field => {
          if (field.field_name === 'interest_name') {
            this.editedItem_interest[field.field_name] = item.interest; // Set to interest ID
          } else {
            this.editedItem_interest[field.field_name] = null;
          }
        });
        this.dialog1 = true;
      },
      close() {
        this.dialog = false;
        this.$refs.skillForm.resetValidation();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      close1() {
        this.dialog1 = false;
        this.$refs.interestForm.resetValidation();
        setTimeout(() => {
          this.editedItem_interest = Object.assign({}, this.defaultItem_interest);
          this.editedIndex_interest = -1;
        }, 300);
      },
    },
    mounted() {
      if (!this.learner) {
        this.learner = localStorage.getItem("learner_for_profile");
      }
      if (this.learner) {
        this.getSkillDetails();
        this.getLearnerInterest();
      }
    },
  };
</script>

<style scoped>
  .custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
  }

  .sibling-table td,
  tr,
  th {
    border-collapse: collapse;
  }

  .button-77 {
    color: #fff;
    cursor: pointer;
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
  }

  .button-77:before,
  .button-77:after {
    border-radius: 80px;
  }

  .button-77:before {
    background-color: rgba(249, 58, 19, 0.32);
    content: "";
  }

  .button-77:after {
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
  }

  .button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
  }

  .button-77:active:not(:disabled) {
    color: #ccc;
  }

  .button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
      linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }

  .button-77:disabled {
    cursor: default;
    opacity: 0.24;
  }

  .main-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .custom-tabs {
    background: linear-gradient(to right, #b2d8f7, #f4d1f4);
    border-radius: 30px;
    padding: 2px;
    min-height: 50px;
  }

  .custom-tab {
    font-weight: normal;
    color: black;
    text-transform: uppercase;
    font-size: 14px;
    min-height: 40px;
    border-radius: 0;
  }

  .first-tab {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .active-tab {
    background: white !important;
    color: black !important;
    font-weight: bold !important;
  }

  .custom-header {
    background: linear-gradient(to right, #ffe0b2, #ffccbc);
    color: black !important;
    font-weight: bold;
  }
</style>